/* eslint-disable prettier/prettier */
// eslint-disable-next-line prettier/prettier
//export const BASE_URL = 'https://api.lcmsbd.com/Api';

export const BASE_URL = 'https://api.bdjudgecourt.com/CourtApi';
//export const BASE_URL = 'http://localhost:19473/CourtApi';

